import { PageScrollService } from 'ngx-page-scroll-core';
import { Component, OnInit } from '@angular/core';

import { SessionService } from '@app/core/services/session.service';
import { HelperService } from '@app/core/services/helper.service';

import { Dealer } from '@app/core/models/dealer.model';

import { DomainHelper } from '@app/core/helpers/domain.helper';

@Component({
	selector: 'cng-terms',
	templateUrl: './terms-of-use.component.html',
	styleUrls: ['../legal-info.less'],
})
export class ConfigureTermsOfUseComponent implements OnInit {
	dealer: Dealer = this.session_service.getDealer();
	domain: string = 'https://' + DomainHelper.getDomain();

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {SessionService} session_service
	 * @param {PageScrollService} page_scroll_service
	 * @param {HelperService} helper_service
	 */
	constructor(
		private session_service: SessionService,
		private page_scroll_service: PageScrollService,
		private helper_service: HelperService
	) {}

	/**
	 * Lifecycle hook: Stops app loading and sets <title> tag.
	 */
	ngOnInit(): void {
		this.session_service.stopAppLoading();
		this.session_service.setTitle('Terms of Use');
	}

	/**
	 * Scrolls window to position of chosen section.
	 *
	 * @param {string} id
	 */
	goTo(id: string): void {
		let offset: number = 0;

		if (this.helper_service.isScreenWidth('==', 'xxs')) {
			offset = 50;
		} else if (this.helper_service.isScreenWidth('==', 'xs')) {
			offset = 60;
		} else if (this.helper_service.isScreenWidth('==', 'sm') || this.helper_service.isScreenWidth('==', 'md')) {
			offset = 80;
		} else {
			offset = 100;
		}

		this.page_scroll_service.scroll({
			document: document,
			scrollTarget: `#${id}`,
			scrollOffset: offset,
		});
	}
}
